import { userApi as api, userSilentApi as silentApi } from "../../utils/apiInstances";

// Function to handle userchange password details
export const handleUserChangePassword = async (
    userData: unknown,
    onSuccess: (res: unknown) => void,
    onError?: (err: unknown) => void
) => {
    try {
        const response = await api("POST", "/user/change-password", userData);
        onSuccess(response);
    } catch (error) {
        if (onError) {
            onError(error);
        }
    }
};

// Function to get user profile
export const handleGetUserProfile = async <TData = unknown>() => {
    try {
        const response = await silentApi<TData>("GET", "/user/profile");
        return response;
    } catch {
        return undefined;
    }
};
// Function to get user referal summary
export const handleGetUserReferalSummary = async <TData = unknown>() => {
    try {
        const response = await silentApi<TData>("GET", "/user/referrals");
        return response;
    } catch {
        return undefined;
    }
};

export const handleDeleteUserProfile = async () => {
    try {
        const response = await silentApi("GET", "/user/delete-account");
        return response;
    } catch {
        return undefined;
    }
};

// Function to handle update user details
export const handleUserUpdateDeatails = async (
    userData: unknown,
    onSuccess: (res: unknown) => void,
    onError?: (err: unknown) => void
) => {
    try {
        const response = await api("POST", "/user/profile", userData);
        onSuccess(response);
    } catch (error) {
        if (onError) {
            onError(error);
        }
    }
};

// Function to get user cards
export const handleGetUserCards = async <TData = unknown>() => {
    try {
        const response = await silentApi<TData>("GET", "/user/cards");
        return response;
    } catch {
        return undefined;
    }
};

// Function to get user wallets by country
export const handleGetUserWallets = async <TData = unknown>() => {
    try {
        const response = await silentApi<TData>("GET", "/user/location/wallets");
        return response;
    } catch {
        return undefined;
    }
};

// Function to create wallet for specific currency
export const handleCreateWalletForCurrency = async (currency: string, countryCode: string) => {
    try {
        const payload: { currency?: string; country_code?: string } = {};
        if (currency) {
            payload.currency = currency;
        }
        if (countryCode) {
            payload.country_code = countryCode;
        }

        const response = await silentApi("POST", "/user/location/wallets", payload);

        if (response?.success) {
            // Fetch updated wallets after ensuring the currency wallet exists
            return await handleGetUserWallets();
        }

        return response;
    } catch (error) {
        throw error;
    }
};

// Function to handle create user card
export const handleUserCreateCard = async (userData: unknown, onSuccess: (res: unknown) => void, onError?: (err: unknown) => void) => {
    try {
        const response = await api("POST", "/user/cards", userData);
        onSuccess(response);
    } catch (error) {
        if (onError) {
            onError(error);
        }
    }
};

// Function to get user cards
export const handleGetUserCardIntent = async (onSuccess: (res: unknown) => void, onError?: (err: unknown) => void) => {
    try {
        const response = await silentApi("GET", "/user/card-intent");
        onSuccess(response);
    } catch (error) {
        if (onError) {
            onError(error);
        }
    }
};

// Function to submit support message
export const handleSubmitSupportMessage = async (
    userData: unknown,
    onSuccess: (res: unknown) => void,
    onError?: (err: unknown) => void
) => {
    try {
        const response = await api("POST", "/user/support-email", userData);
        onSuccess(response);
    } catch (error) {
        if (onError) {
            onError(error);
        }
    }
};

// Function to get current location (country)
export const handleGetCurrentLocation = async <TData = unknown>() => {
    try {
        const response = await api<TData>("GET", "/user/location/country");
        return response;
    } catch (error) {
        throw error;
    }
};

// Function to update location
export const handleUpdateUserLocation = async <TData = unknown>(countryCode: string) => {
    try {
        const response = await api<TData>("PATCH", "/user/location/country", { country_code: countryCode });
        return response;
    } catch (error) {
        throw error;
    }
};
